import type { OpenCrmChatDrawerOptions } from "../CrmChatController";
import type { AskPageContext, CrmRecordType } from "../types/chat.types";

/** Build drawer open options from AskPageContext (bar / ⌘K — story 12.5). */
export function openOptionsFromPageContext(
  workspaceId: string,
  pageContext: AskPageContext
): OpenCrmChatDrawerOptions {
  if (pageContext.kind === "crm-record") {
    return {
      workspaceId,
      pageContext,
      recordId: pageContext.recordId,
      recordType: pageContext.recordType as CrmRecordType,
      displayName: pageContext.displayName ?? pageContext.recordId,
      subtitle: pageContext.subtitle,
      avatarUrl: pageContext.avatarUrl,
    };
  }
  return { workspaceId, pageContext };
}
